import { ClientInferResponseBody } from "@ts-rest/core";

import { contract } from "#app/http/api";
import { api } from "#app/http/api";

export type WeldLengthDto = ClientInferResponseBody<typeof contract.parts.findWeldLength>;

export const fetchWeldLength = async (id: string | undefined): Promise<WeldLengthDto | null> => {
  if (!id) {
    return null;
  }

  const response = await api.parts.findWeldLength.query({ params: { id } });

  if (response.status === 200) {
    return response.body;
  }

  return null;
};
